import React from 'react';
import { formatAffairAmount, formatAffairDate } from '../../affairs/affairFormatters';
import { getPartnerMetrics } from '../partnerMetrics';

const SummaryItem = ({ label, value, secondary = false }) => <div className={secondary ? 'partner-summary-band__item partner-summary-band__item--secondary' : 'partner-summary-band__item'}><span>{label}</span><strong>{value}</strong></div>;

export default function PartnerSummaryBand({ overview, loading = false, error = null }) {
  if (loading) return <div className="partner-summary-band partner-summary-band--loading" role="status">Chargement des indicateurs commerciaux...</div>;
  if (error) return <div className="partner-summary-band partner-summary-band--error" role="alert">Indicateurs indisponibles : {error}</div>;

  const metrics = getPartnerMetrics(overview);
  return <div className="partner-summary-band">
    <SummaryItem label="Affaires en cours" value={metrics.openAffairCount} />
    <SummaryItem label="Potentiel pondéré" value={formatAffairAmount(metrics.weightedPotentialAmount)} />
    <SummaryItem label="Projets actifs" value={metrics.activeProjectCount} />
    <SummaryItem label="Dernière activité" value={metrics.lastActivityAt ? formatAffairDate(metrics.lastActivityAt) : 'Aucune'} />
    <SummaryItem secondary label="Total affaires" value={metrics.affairCount} />
    <SummaryItem secondary label="Devis en attente" value={metrics.pendingQuoteCount} />
    <SummaryItem secondary label="Potentiel brut" value={formatAffairAmount(metrics.potentialAmount)} />
    <SummaryItem secondary label="Montant contractualisé" value={formatAffairAmount(metrics.contractedAmount)} />
  </div>;
}
